<div class="mdl-layout__header-row">
      <button [hidden]="!isBackToResultList" routerLink="./resultlist" mat-icon-button>
        <mat-icon>keyboard_backspace</mat-icon>
      </button>
      <span class="mdl-layout-title header-title">{{title}}</span>
      <div class="mdl-layout-spacer"></div>

      <button class="mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon" id="hdrbtn">
            <i class="material-icons">more_vert</i>
          </button>
      <ul class="mdl-menu mdl-js-menu mdl-js-ripple-effect mdl-menu--bottom-right" for="hdrbtn">
        <li class="mdl-menu__item"  (click)="navigate('terms-of-use');">Terms of use</li>
      </ul>
    </div>
